import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';

function LanguageChangeModal(props) {
    const { t } = useTranslation();
    const { language } = i18n;
    const [selected, setSelected] = useState(language);

    const _onChange = ({ target }) => {
        setSelected(target.value);
    };

    const _selectLanguage = () => {
        i18n.changeLanguage(selected);
        props.onHide();
    };

    return (
        <Modal
            show={props.show}
            onHide={props.onHide}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <div>
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        {t('general.select_language')}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form style={{ paddingBottom: 20, paddingTop: 20 }}>
                        <Form.Check
                            type="radio"
                            id="fi"
                            name="languageFI"
                            label={t('general.fi')}
                            value={'fi'}
                            checked={selected === 'fi'}
                            onChange={_onChange}
                        />
                        <Form.Check
                            type="radio"
                            name="language"
                            id="en"
                            label={t('general.en')}
                            value={'en'}
                            checked={selected === 'en'}
                            onChange={_onChange}
                        />
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" variant="default" onClick={() => props.onHide()}>
                        {t('general.close')}
                    </Button>
                    <Button type="button" variant="success" onClick={_selectLanguage}>
                        {t('general.select')}
                    </Button>
                </Modal.Footer>
            </div>
        </Modal>
    );
}

export default LanguageChangeModal;